import { DOT_WAITING_TIME, EVENT } from '../constants';
import { DEBUG_STATES, spenttimeDebug as debug } from './debug';
import { addEventForCypress } from '../utils/addCustomEvent';
import { completeMeasurement } from './spenttime/measurement';
var dotConfigured = false;
/**
 * Checks that the DOT is loaded and DOT was configured
 * @returns boolean status
 */
export var isDotConfigured = function () {
    var _a, _b;
    if (dotConfigured) {
        return true;
    }
    if ((_b = (_a = window.DOT) === null || _a === void 0 ? void 0 : _a.isConfigured) === null || _b === void 0 ? void 0 : _b.call(_a)) {
        debug('There is DOT');
        dotConfigured = true;
        return true;
    }
    else {
        return false;
    }
};
/**
 * Сhecks that the DOT is loaded and starts the func(funParameters)
 */
export var waitingForDOT = function () {
    // waiting for DOT for DOT_WAITING_TIME ms
    addEventForCypress(EVENT.waitingForDot);
    window.setTimeout(function () {
        if (isDotConfigured()) {
            dotConfigured = true;
        }
        else {
            debug({
                type: 'error',
                message: "Error: There is no DOT or DOT is not configured. Measuring the spenttime is not possible",
                state: DEBUG_STATES.ERROR,
            });
            completeMeasurement();
            addEventForCypress(EVENT.measurementWillNotBePerformed);
        }
    }, DOT_WAITING_TIME);
};
